<!--P106、P107、P108-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy">打印尺寸管理</div>
    </div>
    <!--表格-->
    <div class="cs_margin_top_sm div_search_result cs_padding_top_lg">
      <div class="div_operation_table">
        <button @click="btnAdd" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                type="button">添加
        </button>
        <button @click="btnDelete" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                type="button">删除
        </button>
      </div>
      <div class="cs_margin_top div_table">
        <table class="cs_table cs_thead_fixed cs_td_divider_none" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="185px">名称</th>
            <th width="142px">宽度</th>
            <th width="142px">高度</th>
            <th width="142px">左页边距</th>
            <th width="142px">右页边距</th>
            <th width="142px">顶部页边距</th>
            <th width="100%">底部页边距</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList" :class="{ 'cs_tr_selected': item.isSelected }" @click="btnSelectTableTr(item)">
            <td width="40px">{{index+1}}</td>
            <td width="185px">{{item.pageTypeName}}</td>
            <td width="142px">{{item.pageWidth}}</td>
            <td width="142px">{{item.pageHeight}}</td>
            <td width="142px">{{item.pageLeft}}</td>
            <td width="142px">{{item.pageRight}}</td>
            <td width="142px">{{item.pageTop}}</td>
            <td width="100%">{{item.pageBottom}}</td>
          </tr>
          <template v-if="PAGE_SIZE>orderList.length">
            <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
              <td width="40px"></td>
              <td width="185px"></td>
              <td width="142px"></td>
              <td width="142px"></td>
              <td width="142px"></td>
              <td width="142px"></td>
              <td width="142px"></td>
              <td width="100%"></td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="div_bottom"></div>

    <!--添加弹窗，默认隐藏-->
    <div v-if="isDialogAddShow" class="cs_scrollable_vertical ui_div_dialog">
      <div class="ui_dialog_container" style="width:414px;height:566px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">添加打印尺寸</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">名称</div>
          <input v-model="dialogAdd.name" class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_58" placeholder="请输入">
        </div>
        <div class="ui_margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">宽度</div>
          <input v-model="dialogAdd.width" class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_58" placeholder="请输入">
        </div>
        <div class="ui_margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">高度</div>
          <input v-model="dialogAdd.height" class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_58" placeholder="请输入">
        </div>
        <div class="ui_margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">左页边距</div>
          <input v-model="dialogAdd.left" class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_30" placeholder="请输入">
        </div>
        <div class="ui_margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">右页边距</div>
          <input v-model="dialogAdd.right" class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_30" placeholder="请输入">
        </div>
        <div class="ui_margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">顶部页边距</div>
          <input v-model="dialogAdd.top" class="cs_input cs_radius_lg edtxt_info_search width_246" placeholder="请输入">
        </div>
        <div class="ui_margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">底部页边距</div>
          <input v-model="dialogAdd.bottom" class="cs_input cs_radius_lg edtxt_info_search width_246" placeholder="请输入">
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog">{{dialogAdd.hint}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialog">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmDialog">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Page, PAGE_SIZE} from "../../assets/utils/constants"
  import WhParameter from "../../assets/csui/parameter/WhParameter";
  export default {
    name: "PrintManage",
    components: {},
    data: function () {
      return {
        orderList: [],
        selectedId: "",
        isDialogAddShow : false,
        dialogAdd:{
          name: "",
          width:"",
          height:"",
          top:"",
          left:"",
          right:"",
          bottom:"",
          hint:"",
        },
        PAGE_SIZE: PAGE_SIZE,
      }
    },
    created: function () {
      this.showList();
    },
    mounted: function() {
    },
    methods: {
      showList() {
        this.selectedId="";
        this.$ajax.printTemplate.list.bind(this)((data) => {
          //显示列表
          let list = data.data;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.orderList = list;
        }, (data) => {
        }, true)
      },
      btnSelectTableTr(item){
        let selectedStatus = item.isSelected;
        this.orderList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedId = item.id;
        }else {
          this.selectedId = "";
        }
      },
      btnDelete(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$alert("确认删除该打印尺寸吗？", (clickConfirm) => {
          if (clickConfirm) {
            this.$ajax.printTemplate.delete.bind(this)(this.selectedId, (data) => {
              this.$toast("删除成功");
              this.showList();
            }, (data) => {
            }, true)
          }
        }, true);
      },
      btnAdd(){
        this.isDialogAddShow = true;
      },
      btnConfirmDialog(){
        try {
          WhParameter.verifyNotEmpty(this.dialogAdd.name,"名称");
          WhParameter.verifyNotEmpty(this.dialogAdd.width,"宽度");
          WhParameter.verifyNotEmpty(this.dialogAdd.height,"高度");
          WhParameter.verifyNotEmpty(this.dialogAdd.left,"左页边距");
          WhParameter.verifyNotEmpty(this.dialogAdd.right,"右页边距");
          WhParameter.verifyNotEmpty(this.dialogAdd.top,"顶部页边距");
          WhParameter.verifyNotEmpty(this.dialogAdd.bottom,"底部页边距");
        }catch (e) {
          this.dialogAdd.hint = e.message;
          return;
        }
        this.$ajax.printTemplate.add.bind(this)(this.dialogAdd, (data) => {
          this.$toast("添加成功");
          this.showList();
          this.closeDialog();
        }, (data) => {
        }, true,this.showErrorMsg)
      },
      closeDialog() {
        this.isDialogAddShow = false;
        this.dialogAdd={
          name: "",
          width:"",
          height:"",
          top:"",
          left:"",
          right:"",
          bottom:"",
          hint:"",
        };
      },
      //错误提示
      showErrorMsg: function (msg) {
        this.dialogAdd.hint = msg;
      },
    },
  }
</script>

<style scoped>
  .cs_table tbody {
    max-height: 411px;
  }
  .txt_hint_dialog{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #FFB54C;
    text-align: center;
  }
  .width_246{width: 246px;}
</style>



// WEBPACK FOOTER //
// src/page/print/PrintManage.vue